import { isActionable } from './grouping';
import { useGetOutstandingItemsQuery } from './outstanding.api';

/**
 * How many items still need this director's signature or payment.
 *
 * Reads the same cached query the dashboard renders, so the badge costs no
 * extra request and cannot disagree with the list — it is literally the same
 * data. Zero while loading, so the badge appears once rather than flickering
 * through a wrong number on the way to the right one.
 *
 * Counts only what the director can act on. An item this director has already
 * signed but co-directors have not is not their task, and counting it made the
 * nav badge promise work the list then refused to offer.
 */
export const useOutstandingCount = (): number => {
  const { data } = useGetOutstandingItemsQuery({});
  return data?.filter(isActionable).length ?? 0;
};
